<template>

    <div class="animated fadeIn">

        <b-row class="mt-2">
            <b-col>
                <h4>Puntue del 1 al 5 la satisfacción general obtenida durante todo el proceso.</h4>
            </b-col>
        </b-row>

        <b-row class="mt-2">
            <b-col>
                <valuation-selector v-model="valuation"></valuation-selector>
            </b-col>
        </b-row>

    </div>

</template>

<script>
    import ValuationSelector from "./ValuationSelector";

    export default {
        name: "SatisfactionQuestion",
        components: {
            ValuationSelector
        },
        props: {
            value: Number
        },
        data: function () {
            return {
                valuation: this.value
            }
        },
        watch: {
            'valuation': function(){
                this.$emit('input', parseInt(this.valuation));
            },
        }
    }
</script>